module.exports = __webpack_public_path__ + "img/logo.d4c21edb.png";